import { NotificationService } from './../../shared/services/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService extends ErrorHandler {
  private readonly notification = inject(NotificationService);

  handleError(error: Error | HttpErrorResponse): void {
    console.error(error);

    if (error.name === 'TypeError') {
      return;
    }

    if (error instanceof HttpErrorResponse && error.status === 401) {
      return;
    }

    if (error.message?.includes('401')) {
      return;
    }

    if (error?.message) {
      this.notification.error(error.message);
    }
  }
}
